import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Stack, Typography, Checkbox, TextField, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { useMutation } from 'react-fetching-library';
import { calculateRoadToSchoolDistance } from '../../../../../../services/request';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';


const ReservationDataForm = ({ formik }) => {
  const { module, seasonIdentifier, seasonYear } = useSelector(state => state.app);
  const { order } = useSelector(state => state.orderData);
  const navigate = useNavigate();

  const { mutate } = useMutation(calculateRoadToSchoolDistance);
  const recalculateDistance = async () => {
    const { error, payload } = await mutate(order.id);
    if (error) {
      toast.error('Nie udało się przeliczyć dystansu pomiędzy szkołą a ośrodkiem. Upewnij się że adres szkoły jest poprawny');
    } else {
      formik.setFieldValue('road_distance_to_school', payload.distance);
      if (Number(payload.distance) > 200) {
        formik.setFieldValue('provisions', true);
      }
    }
  };

  return (
    <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box display="flex" flexDirection="column" justifyContent="space-between" mt={1} width="100%">
        <Card>
          <CardContent>
            <Stack direction="row">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 50%">
                <Typography variant="subtitle2">Źródło oferty</Typography>
                <TextField id="source_of_offer" name="source_of_offer" placeholder="źródło oferty" size="small" sx={{ flexGrow: 0.98 }} value={formik.values.source_of_offer} onChange={formik.handleChange}/>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 50%">
                <Typography variant="subtitle2">Forma komunikacji</Typography>
                <TextField id="form_of_communication" name="form_of_communication" placeholder="forma komunikacji" size="small" sx={{ flexGrow: 1 }} value={formik.values.form_of_communication} onChange={formik.handleChange}/>
              </Stack>
            </Stack>
            <Box height={20}/>
            <Stack direction="row">
              <Stack direction="row" spacing={2} flex="1 1 50%">
                <Stack>
                  <Stack direction="row" justifyContent={'space-around'}>
                    <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                      <Checkbox id="return_of_health_card" name="return_of_health_card" checked={formik.values.return_of_health_card} onChange={formik.handleChange}/>
                      <Typography variant="subtitle2">{module == 'zielone_szkoly' ? 'Zwrot listy do ubezpieczenia' : 'Zwrot karty zdrowia'}</Typography>
                    </Stack>
                  </Stack>
                  <Box height={20}/>
                  <Stack direction="row" justifyContent={'space-around'}>
                    <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                      <Checkbox
                        id="return_agreement"
                        name="return_agreement"
                        checked={formik.values.return_agreement}
                        onChange={formik.handleChange}
                        disabled={['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier)} />
                      <Typography variant="subtitle2">Zwrot umowy</Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  {module != 'zielone_szkoly'
                    ? <TextField
                      maxWidth
                      id="reservation_notes"
                      name="reservation_notes"
                      placeholder="Uwagi odnośnie rezerwacji"
                      value={formik.values.reservation_notes} onChange={formik.handleChange}
                      multiline
                      rows={4}
                      sx={{ minWidth: '600px' }}

                    />
                    : null}
                </Stack>
              </Stack>
              <Stack direction="row" justifyContent={'space-around'} alignItems="left" flex="1 1 50%">
                {['obozy', 'wyjazdy_rodzinne'].includes(module) && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                  <Checkbox
                    id="quick_payment_promotion"
                    name="quick_payment_promotion"
                    checked={formik.values.quick_payment_promotion}
                    onChange={formik.handleChange}
                  />
                  <Typography variant="subtitle2">Korzysta z promocji szybkiej płatności</Typography>
                </Stack>}
              </Stack>
            </Stack>
            {/* <Box height={20}/>
            <Stack direction="row">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                <Checkbox id="annex_return" name="annex_return" checked={formik.values.annex_return} onChange={formik.handleChange}/>
                <Typography variant="subtitle2">Zwrot aneksu</Typography>
              </Stack>
              <Box sx={{ flex: '1 1 80%' }} />
            </Stack> */}
            <Box height={20}/>
            {module == 'zielone_szkoly'
              ? <Stack direction="row">
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                  <Checkbox id="provisions" name="provisions" checked={formik.values.provisions} onChange={formik.handleChange}/>
                  <Typography variant="subtitle2">Prowiant {formik.values.road_distance_to_school ? `(${formik.values.road_distance_to_school} km)` : ''}</Typography>
                  <Button onClick={recalculateDistance}><RefreshIcon/></Button>
                </Stack>
                <Box sx={{ flex: '1 1 80%' }} />
              </Stack>
              : <Stack direction="column">
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                    <Checkbox id="accommodated" name="accommodated" disabled checked={order.accommodated}/>
                    <Typography variant="subtitle2">Zakwaterowano</Typography>
                  </Stack>
                  <Box sx={{ flex: '1 1 80%' }} />
                </Stack>
                <Stack width="20%">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(`/employee/accommodation/${order.resort}/${order.camp}/`)}>
                    {order.accommodated ? 'Przejdź do zakwaterowania' : 'Zakwateruj'}
                  </Button>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                  <Checkbox
                    disabled={!formik.values.shared_accommodation_changed}
                    id="shared_accommodation_changed"
                    name="shared_accommodation_changed"
                    checked={formik.values.shared_accommodation_changed}
                    onChange={formik.handleChange}
                  />
                  <Typography variant="subtitle2">Alarmuj o wspólnym zakwaterowaniu</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                  <Checkbox
                    id="show_shared_accommodation_confirmation"
                    name="show_shared_accommodation_confirmation"
                    checked={formik.values.show_shared_accommodation_confirmation}
                    onChange={formik.handleChange}
                  />
                  <Typography variant="subtitle2">Wyświetlaj potwierdzenie wspólnego zakwaterowania w Panelu Rodzica</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} width="50%">
                  <Typography variant="subtitle2">Prefix zakwaterowania</Typography>
                  <TextField disabled id="accommodation_prefix" name="accommodation_prefix" placeholder="" size="small" sx={{ flexGrow: 1 }} value={order.accommodation_prefix} onChange={formik.handleChange}/>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} width="50%" mt={1}>
                  <Typography variant="subtitle2">Grupa imprezowa</Typography>
                  <SmallFormTextField
                    select
                    name="accommodation_event_group"
                    placeholder="grupa imprezowa"
                    options={order.resort_event_camp_data.event_groups}
                    value={formik.values.accommodation_event_group}
                    onChange={formik.handleChange}
                    error={formik.touched.accommodation_event_group && Boolean(formik.errors.accommodation_event_group)}
                    helperText={formik.touched.accommodation_event_group && formik.errors.accommodation_event_group}
                  />
                </Stack>
              </Stack>}
            {(module != 'zielone_szkoly')
              ? <><Stack direction="row">
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%" mt={2}>
                  <Checkbox id="qualification_card_returned" disabled={true} name="qualification_card_returned" checked={formik.values.qualification_card_returned} onChange={formik.handleChange}/>
                  <Typography variant="subtitle2">Wypełniono kartę</Typography>
                </Stack>
                <Box sx={{ flex: '1 1 80%' }} />
              </Stack>
              <Stack direction="row">
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%" p={2}>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Kwalifikacja</FormLabel>
                    <RadioGroup
                      aria-labelledby="classification-radio-buttons-group-label"
                      defaultValue= {formik.values.classification}
                      name="classification-radio-buttons-group"
                      onChange={event => {
                        const value = event.target.value === '' ? null : parseInt(event.target.value);
                        formik.setFieldValue('classification', value);
                      }}

                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio />}
                        label="Zakwalifikowano"
                        disabled={!formik.values.qualification_card_returned || !formik.values.attachments.find(a => a.attachment_type == 'qualification_card')}/>
                      <FormControlLabel
                        value={2}
                        control={<Radio />}
                        label="Nie zakwalifikowano"
                        disabled={!formik.values.qualification_card_returned || !formik.values.attachments.find(a => a.attachment_type == 'qualification_card')}/>
                      <FormControlLabel value={''} control={<Radio />} label="Brak decyzji" />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                {formik.values.classification == 2
                  ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                    <Typography variant="subtitle2" minWidth={'140px'}>Ze względu na</Typography>
                    <TextField
                      id="classification_details"
                      name="classification_details"
                      placeholder="Powód odmowy skierowania"
                      value={formik.values.classification_details} onChange={formik.handleChange}
                      multiline
                      rows={3}
                      sx={{ minWidth: '600px' }}
                    />
                  </Stack>
                  : null }
                <Box sx={{ flex: '1 1 80%' }} />
              </Stack>
              </>
              : null}
            {module === 'zielone_szkoly'
              ? <>
                <Box height={20}/>
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                    <Checkbox id="without_photos" name="without_photos" checked={formik.values.without_photos} onChange={formik.handleChange}/>
                    <Typography variant="subtitle2">Bez fotografii</Typography>
                  </Stack>
                  <Box sx={{ flex: '1 1 80%' }} />
                </Stack>
              </>
              : null}
            {order.boskie_wakacje
              ? <>
                <Box height={20} /><Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2">Parafia</Typography>
                  <TextField id="parish_name" name="parish_name" placeholder="parafia" size="small" sx={{ flexGrow: 1 }} value={formik.values.parish_name} onChange={formik.handleChange} />
                </Stack>
              </>
              : null}
            {module != 'zielone_szkoly' ? <>
              <Box height={20}/>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2">Numer karty rodziny</Typography>
                <TextField id="family_card_number" name="family_card_number" placeholder="numer karty rodziny" size="small" sx={{ flexGrow: 1 }} value={formik.values.family_card_number} onChange={formik.handleChange} />
              </Stack>
            </> : null}
            <Box height={20}/>
            <Stack direction="column">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="rodo_terms" name="rodo_terms" checked={formik.values.rodo_terms} onChange={formik.handleChange}/>
                <Typography variant="subtitle2">RODO - akceptacja warunków</Typography>
              </Stack>
              {module != 'zielone_szkoly' && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="participation_terms" name="participation_terms" checked={formik.values.participation_terms} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Akceptacja warunków uczestnictwa</Typography>
              </Stack>}
              { seasonYear >= 2025 && <>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_email" name="marketing_consents_email" checked={formik.values.marketing_consents_email} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych e-mail</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_sms" name="marketing_consents_sms" checked={formik.values.marketing_consents_sms} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych SMS/MMS</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_phone" name="marketing_consents_phone" checked={formik.values.marketing_consents_phone} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych rozmowa tel.</Typography>
                </Stack>
              </>}
              {(module == 'obozy' && seasonYear > 2025) && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="payment_terms_accepted" name="payment_terms_accepted" checked={formik.values.payment_terms_accepted} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Zapoznanie z warunkami płatności</Typography>
              </Stack> }
              {((module == 'zielone_szkoly' && seasonYear < 2026) || (module == 'obozy' && seasonYear < 2025)) && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="other_terms" name="other_terms" checked={formik.values.other_terms} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Akceptacja zgód marketingowych</Typography>
              </Stack> }
              {(module == 'zielone_szkoly' && seasonYear > 2025) && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="marketing_consents_survey" name="marketing_consents_survey" checked={formik.values.marketing_consents_survey} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Akceptacja wysyłki ankiet</Typography>
              </Stack> }
              {module == 'obozy' && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="info_form" name="info_form" checked={formik.values.info_form} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Zapoznanie się z formularzem informacyjnym</Typography>
              </Stack>}
            </Stack>
            {module == 'obozy' ? <>
              <Box height={20} />
              <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
                <Typography variant="subtitle2">Rozmiar T-shirt</Typography>
                <SmallFormTextField
                  sx={{ width: 200 }}
                  select
                  name="tshirt_size"
                  placeholder=""
                  options={['7-8 lat', '9-11 lat', '12-14 lat', 'XS', 'S', 'M', 'L', 'XL', 'XXL'].map(value => ({ value, label: value }))}
                  value={formik.values.tshirt_size}
                  onChange={e => formik.handleChange(e)}
                />
              </Stack>
            </> : null}
            <Box height={20} />
            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Przyjaciele promocja</Typography>
              <SmallFormTextField
                name="friends"
                type="text"
                placeholder="przyjaciele"
                disabled
                multiline
                rows={3}
                value={formik.values.friends_display}
                onChange={formik.handleChange}
              />
            </Stack>
            <Box height={40} />
            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Rodzeństwo promocja</Typography>
              <SmallFormTextField
                name="siblings"
                type="text"
                placeholder="rodzeństwo"
                disabled
                multiline
                rows={3}
                value={formik.values.siblings_display}
                onChange={formik.handleChange}
              />
            </Stack>
            <Box height={40} />
            <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Ekipa promocja</Typography>
              <SmallFormTextField
                name=""
                type="text"
                placeholder="ekipa"
                disabled
                multiline
                rows={3}
                value={formik.values.team_display}
                onChange={formik.handleChange}
              />
            </Stack>
            <Box height={20}/>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2">Kod rabatowy</Typography>
              <TextField id="discount_code" name="discount_code" placeholder="kod rabatowy" size="small" sx={{ flexGrow: 1 }} value={formik.values.discount_code} onChange={formik.handleChange} />
            </Stack>
            {(module == 'obozy' && seasonYear > 2025) && <>
              <Box height={20} />
              <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
                <Typography variant="subtitle2">Status klienta</Typography>
                <SmallFormTextField
                  select
                  name="client_status"
                  placeholder="status klienta"
                  options={[
                    { value: 'returning', label: 'JESTEM STAŁYM KLIENTEM (jedno z moich dzieci przynajmniej raz uczestniczyło w LETNIM OBOZIE SUN SPORT)' },
                    { value: 'new', label: 'JESTEM NOWYM KLIENTEM' }
                  ]}
                  value={formik.values.client_status}
                  onChange={formik.handleChange}
                />
              </Stack>
              {/* 1- RETURNING, 2-NEW client_status */}
              {formik.values.client_status == 'new'
                ? <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
                  <Typography variant="subtitle2">&quot;Czy obóz został polecony klientowi przez znajomego?&quot;</Typography>
                  <SmallFormTextField
                    select
                    name="camp_recommended_by_client_friend"
                    options={[
                      { value: true, label: 'TAK' },
                      { value: false, label: 'NIE' }
                    ]}
                    value={formik.values.camp_recommended_by_client_friend}
                    onChange={formik.handleChange}
                  />
                </Stack> : null}
            </>}
            {module === 'polkolonie'
              ? <>
                <Box height={20}/>
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                    <Checkbox id="canoeing_activities" name="canoeing_activities" checked={formik.values.canoeing_activities} onChange={formik.handleChange}/>
                    <Typography variant="subtitle2">Udział w zajęciach kajakarskich</Typography>
                  </Stack>
                  <Box sx={{ flex: '1 1 80%' }} />
                  <Box height={20} />
                  <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
                    <Typography variant="subtitle2">Rodzaj promocji dla przyjaciół</Typography>
                    <SmallFormTextField
                      sx={{ width: 200 }}
                      select
                      name="friends_promotion_choice"
                      placeholder=""
                      options={[{ value: 'discount', label: 'Rabat' }, { value: 'gadget', label: 'Gadźet' }]}
                      value={formik.values.friends_promotion_choice}
                      onChange={e => formik.handleChange(e)}
                    />
                  </Stack>
                </Stack>
              </>
              : null}
          </CardContent>
        </Card>
        {/* new consents sience 2026 */}
        {/* <Consents formik={formik}/> */}
      </Box>
    </form>
  );
};


export default ReservationDataForm;
